


















import { Component, Prop, Vue } from 'vue-property-decorator';
import { ChartSummariesService } from '../services/ChartSummariesService';
import { ChartSummaries } from '../models/chartSummaries';
import { Consoler } from '@/utils/Consoler';
import { Config } from '../utils/Config';

@Component
export default class SummaryCharts extends Vue {
  @Prop() private year!: number;
  @Prop() private show!: boolean;

  private chartSummaries: ChartSummaries | null = null;
  private loading: boolean = false;
  private error: boolean = false;

  private get chartOptions() {
    if (this.chartSummaries === null) {
      return {};
    }

    const series = [
    {
      name: this.$t('summaryCharts.chartSeriesTitle') + ' ' + this.chartSummaries.year,
      data: this.chartSummaries.averageQuantities,
      color: Config.Settings.ChartsPrimaryColor,
      showInLegend: true
    }];

    if (this.chartSummaries.hasComparisonData) {
      series.push({
        name: this.$t('summaryCharts.chartSeriesTitle') +
          (this.chartSummaries.comparisonYear !== null ? ' ' + this.chartSummaries.comparisonYear : ''),
        data: this.chartSummaries.comparisonAverageQuantities,
        color: Config.Settings.ChartsSecondaryColor,
        showInLegend: true
      });
    }

    return {
      chart: {
        type: 'column'
      },
      title: {
        text: this.$t('summaryCharts.header')
      },
      tooltip: {
        valueSuffix: ' ' + this.$t('pcs')
      },
      xAxis: {
        categories: this.chartSummaries.weeks.map((w) => {
          return this.$t('week') + ' ' + w;
        })
      },
      yAxis: [{
        labels: {
          format: '{value} ' + this.$t('pcs')
        },
        title: '',
        softMax: 100
      }],
      plotOptions: {
        series: {
            minPointLength: 2
        }
      },
      series,
      credits: false
    }
  }

  mounted() {
    this.loadChartSummaries();
  }

  private loadChartSummaries(): Promise<any> {
    this.chartSummaries = null;
    this.loading = true;
    this.error = false;

    return ChartSummariesService.getChartSummaries(this.year)
      .then(response => {          
        const chartSummaries: ChartSummaries = response && response.data;
        Consoler.debugLog('Successfully fetched chart summaries from API', chartSummaries);
        this.chartSummaries = chartSummaries;
      })
      .catch(error => {
        Consoler.debugWarn('Failed to fetch chart summaries from API', error);
        this.error = true;
      })
      .finally(() => {
        this.loading = false;
      });
  }
}
